import React from 'react';
import { FormLocation } from '../../../../utils/mappers/serviceMapper/service.mapper';
import { useTranslation } from '@wix/yoshi-flow-editor';
import { LocationDataHooks } from './dataHooks';
import Text, { TextType } from '../../Text/Text';
import { LocationType } from '@wix/ambassador-bookings-v2-booking/types';
import { TFunction } from '../../../../types/types';
import { TagName } from '../../../../utils/tagName.const';
import { classes } from './Location.st.css';

export interface LocationProps {
  location: FormLocation;
}
const Location: React.FC<LocationProps> = ({ location }) => {
  const { t } = useTranslation();
  const locationText = getLocationText(location, t);

  return (
    <Text
      type={TextType.Secondary}
      data-hook={LocationDataHooks.LOCATION}
      tagName={TagName.Paragraph}
      className={classes.root}
    >
      {locationText}
    </Text>
  );
};

const getLocationText = (location: FormLocation, t: TFunction): string => {
  switch (location?.locationType) {
    case LocationType.OWNER_BUSINESS:
      return location?.name!;
    case LocationType.OWNER_CUSTOM:
      return location?.address!;
    case LocationType.CUSTOM:
      return t('app.booking-details.locations.client-place.text');
    default:
      return '';
  }
};

export default Location;
